import { render, staticRenderFns } from "./EliminarImagen.vue?vue&type=template&id=aff43d4e"
import script from "./EliminarImagen.vue?vue&type=script&lang=js"
export * from "./EliminarImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports